// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j86MO","badges":"styles_badges__2CBGI"};